import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
export const OfflineBanner = ({ sx, isOffline, dataTestId }) => {
    return (isOffline && (_jsx(Box, { "data-testid": dataTestId, sx: sx, bgcolor: '#c8cdd0', color: 'white', textAlign: 'center', alignSelf: 'center', children: "Offline" })));
};
